export default "__VITE_ASSET__BCgvdbLB__"